import { createProductTour } from '@thehotelsnetwork/vue-product-tour';

export const productTour = createProductTour({
  id: '86927',
});
